import { useModalStore } from "../../../stores/modalStore.js";

export function NotificationsModal() {
  const { isOpen, type, onClose } = useModalStore();

  if (!isOpen || type !== "notifications") return null;

  const notifications = [
    { id: 1, type: "mention", server: "Foundation", channel: "general", author: "Trevor", message: "@you check this out", time: "2m ago", unread: true },
    { id: 2, type: "reply", server: "Labs", channel: "experiments", author: "Marcus", message: "Replied to your message", time: "15m ago", unread: true },
    { id: 3, type: "dm", author: "ShadowForce", message: "Hey, are you available?", time: "1h ago", unread: false },
  ];

  return (
    <div
      onClick={onClose}
      style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: "rgb(var(--aethex-panel))", border: "1px solid rgb(var(--aethex-border))", borderRadius: 10, width: "90%", maxWidth: 600, maxHeight: "80vh", overflow: "hidden", display: "flex", flexDirection: "column" }}
      >
        <div style={{ padding: "16px 20px", borderBottom: "1px solid rgb(var(--aethex-border))", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, color: "rgb(var(--aethex-text))", margin: 0 }}>🔔 Notifications</h2>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "rgb(var(--aethex-dim))", fontSize: 20, cursor: "pointer" }}>✕</button>
        </div>

        <div style={{ flex: 1, overflow: "auto" }}>
          {notifications.length === 0 ? (
            <div style={{ padding: "60px 20px", textAlign: "center", color: "rgb(var(--aethex-dim))" }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>🔔</div>
              <p>No new notifications</p>
            </div>
          ) : (
            notifications.map((notif) => (
              <div
                key={notif.id}
                style={{
                  padding: "14px 20px",
                  borderBottom: "1px solid rgb(var(--aethex-border))",
                  background: notif.unread ? "rgb(var(--aethex-primary)/0.06)" : "transparent",
                  cursor: "pointer",
                  transition: "background 0.15s",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = "rgb(var(--aethex-surface))"; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = notif.unread ? "rgb(var(--aethex-primary)/0.06)" : "transparent"; }}
              >
                <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                  <div style={{ width: 38, height: 38, borderRadius: "50%", background: "rgb(var(--aethex-primary)/0.2)", border: "1px solid rgb(var(--aethex-primary)/0.3)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0 }}>
                    {notif.type === "mention" ? "@" : notif.type === "reply" ? "💬" : "📩"}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3, gap: 8 }}>
                      <span style={{ color: "rgb(var(--aethex-text))", fontWeight: 600, fontSize: 14 }}>
                        {notif.author}
                        {notif.server && <span style={{ color: "rgb(var(--aethex-dim))", fontWeight: 400 }}> in #{notif.channel}</span>}
                      </span>
                      <span style={{ fontSize: 11, color: "rgb(var(--aethex-dim))", flexShrink: 0 }}>{notif.time}</span>
                    </div>
                    <p style={{ color: "rgb(var(--aethex-muted))", fontSize: 13, margin: 0 }}>{notif.message}</p>
                    {notif.server && (
                      <span style={{ fontSize: 11, color: "rgb(var(--aethex-primary))", marginTop: 3, display: "inline-block" }}>{notif.server}</span>
                    )}
                  </div>
                  {notif.unread && (
                    <div style={{ width: 8, height: 8, borderRadius: "50%", background: "rgb(var(--aethex-primary))", flexShrink: 0, marginTop: 6 }} />
                  )}
                </div>
              </div>
            ))
          )}
        </div>

        <div style={{ padding: "12px 20px", borderTop: "1px solid rgb(var(--aethex-border))", display: "flex", justifyContent: "space-between", gap: 8 }}>
          <button style={{ padding: "8px 16px", background: "none", border: "1px solid rgb(var(--aethex-border))", borderRadius: 6, color: "rgb(var(--aethex-muted))", cursor: "pointer", fontFamily: "'Roboto Mono', monospace", fontSize: 12 }}>
            Mark All Read
          </button>
          <button onClick={onClose} style={{ padding: "8px 20px", background: "rgb(var(--aethex-primary)/0.8)", border: "none", borderRadius: 6, color: "#fff", cursor: "pointer", fontFamily: "'Roboto Mono', monospace", fontSize: 12, fontWeight: 600 }}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
